import { errorHandle } from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import {
  SET_LIST_SERVICE,
  SET_LIST_BILLER_SERVICE,
  PROCESSING,
  PROCESSING_DONE,
  SET_SERVICE,
} from './types';

const { allBillerApiService } = apiService.getInstance();

export const getListService = (paginationUrl, paramUrl = '') => dispatch => {
  dispatch({ type: PROCESSING });

  const serviceUrl = `services?${paginationUrl}${paramUrl}`;

  allBillerApiService
    .get(serviceUrl)
    .then(serviceBiller.onGetListServiceSuccess(dispatch))
    .catch(serviceBiller.onGetListServiceError(dispatch));
};

export const onGetListServiceSuccess = dispatch => response => {
  if (response.status === 200) {
    const { payload, pagination } = response.data;
    dispatch({
      type: SET_LIST_SERVICE,
      payload,
      pagination,
    });
  }
};

export const onGetListServiceError = dispatch => error => {
  dispatch({ type: SET_LIST_SERVICE, payload: [], pagination: {} });
  errorHandle(error);
};

export const getService = (id, callback) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .get(`services/${id}`)
    .then(serviceBiller.onGetServiceSuccess(dispatch, callback))
    .catch(serviceBiller.onGetServiceError(dispatch));
};

export const onGetServiceSuccess = (dispatch, callback) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    dispatch({ type: SET_SERVICE, payload });
    if (callback) {
      callback();
    }
  }
};

export const onGetServiceError = dispatch => error => {
  dispatch({ type: SET_SERVICE, payload: {} });
  errorHandle(error);
};

export const syncConsent = (serviceData, type, dispatch, callback) => {
  const messageType = type === 'create' ? 'Create' : 'Update';
  allBillerApiService
    .post('dana/search/onboard', {
      entity_type: 'SERVICE',
      entity_id: serviceData.id,
    })
    .then(
      serviceBiller.onSyncConsentSuccess(
        dispatch,
        callback,
        serviceData,
        type,
        messageType,
      ),
    )
    .catch(
      serviceBiller.onSyncConsentError(
        dispatch,
        callback,
        serviceData,
        type,
        messageType,
      ),
    );
};

export const onSyncConsentSuccess = (
  dispatch,
  callback,
  serviceData,
  type,
  messageType,
) => response => {
  if (response.status === 204) {
    dispatch({ type: SET_SERVICE, payload: serviceData });

    callback(serviceData.id, true, type, [
      {
        status: 'success',
        message: `${messageType} Service: Success`,
      },
      // {
      //   status: 'success',
      //   message: 'Sync to Global Search: Success',
      // },
    ]);
  }
};

export const onSyncConsentError = (
  dispatch,
  callback,
  serviceData,
  type,
  messageType,
) => error => {
  callback(serviceData.id, true, type, [
    {
      status: 'success',
      message: `${messageType} Service: Success`,
    },
    // {
    //   status: 'failed',
    //   message: 'Sync to Global Search: Failed',
    //   info: error.response.data.message.detail,
    // },
  ]);
  dispatch({ type: SET_SERVICE, payload: serviceData });
  errorHandle(error);
};

export const createNewService = (
  params,
  isSyncConsent,
  callback,
) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .post('services', params)
    .then(
      serviceBiller.onCreateNewServiceSuccess(
        dispatch,
        callback,
        isSyncConsent,
      ),
    )
    .catch(serviceBiller.onCreateNewServiceError(dispatch, callback));
};

export const onCreateNewServiceSuccess = (
  dispatch,
  callback,
  isSyncConsent,
) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    if (isSyncConsent) {
      serviceBiller.syncConsent(payload, 'create', dispatch, callback);
    } else {
      dispatch({ type: SET_SERVICE, payload });
      callback(payload.id, true, 'create', [
        { status: 'success', message: 'Create Service: Success' },
        // {
        //   status: 'pending',
        //   message: 'Sync to Global Search: Not Processed',
        // },
      ]);
    }
  }
};

export const onCreateNewServiceError = (dispatch, callback) => error => {
  callback(null, false, 'create', [
    { status: 'failed', message: 'Create Service: Failed' },
    // {
    //   status: 'pending',
    //   message: 'Sync to Global Search: Not Processed',
    // },
  ]);
  dispatch({ type: SET_SERVICE, payload: {} });
  errorHandle(error);
};

export const updateService = (
  id,
  params,
  type,
  isSyncConsent,
  callback,
) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .patch(`services/${id}`, params)
    .then(
      serviceBiller.onUpdateServiceSuccess(
        id,
        type,
        isSyncConsent,
        dispatch,
        callback,
      ),
    )
    .catch(serviceBiller.onUpdateServiceError(id, dispatch, callback));
};

export const onUpdateServiceSuccess = (
  id,
  type,
  isSyncConsent,
  dispatch,
  callback,
) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    if (type === 'archive') {
      dispatch(
        serviceBiller.updateStatus(id, 'archive', isSyncConsent, callback),
      );
    } else if (isSyncConsent) {
      serviceBiller.syncConsent(payload, type, dispatch, callback);
    } else {
      dispatch({ type: SET_SERVICE, payload });
      callback(id, true, type === 'inactive' ? 'inactive' : 'update', [
        { status: 'success', message: 'Update Service: Success' },
        // {
        //   status: 'pending',
        //   message: 'Sync to Global Search: Not Processed',
        // },
      ]);
    }
  }
};

export const onUpdateServiceError = (id, dispatch, callback) => error => {
  dispatch({ type: PROCESSING_DONE });
  callback(id, false, true, [
    { status: 'failed', message: 'Update Service: Failed' },
    // {
    //   status: 'pending',
    //   message: 'Sync to Global Search: Not Processed',
    // },
  ]);
  errorHandle(error);
};

export const getListBillerService = (id, params, callback) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .get(`services/${id}/billers`, { params })
    .then(serviceBiller.onGetListBillerServiceSuccess(dispatch, callback))
    .catch(serviceBiller.onGetListBillerServiceError(dispatch, callback));
};

export const onGetListBillerServiceSuccess = (
  dispatch,
  callback,
) => response => {
  if (response.status === 200) {
    const { payload, pagination } = response.data;
    dispatch({
      type: SET_LIST_BILLER_SERVICE,
      payload,
    });
    callback(pagination);
  }
};

export const onGetListBillerServiceError = (dispatch, callback) => error => {
  errorHandle(error);
  dispatch({
    type: SET_LIST_BILLER_SERVICE,
    payload: [],
  });
  callback(error);
};

export const updateStatus = (id, type, isSyncConsent, callback) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .post(`services/${id}/${type}`)
    .then(
      serviceBiller.onUpdateStatusSuccess(
        id,
        type,
        isSyncConsent,
        dispatch,
        callback,
      ),
    )
    .catch(serviceBiller.onUpdateStatusError(id, type, dispatch, callback));
};

export const onUpdateStatusSuccess = (
  id,
  type,
  isSyncConsent,
  dispatch,
  callback,
) => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    dispatch({ type: SET_SERVICE, payload });
    if (isSyncConsent) {
      serviceBiller.syncConsent(payload, type, dispatch, callback);
    } else {
      callback(id, true, type, [
        { status: 'success', message: 'Update Service: Success' },
        // {
        //   status: 'pending',
        //   message: 'Sync to Global Search: Not Processed',
        // },
      ]);
    }
  }
};

export const onUpdateStatusError = (id, type, dispatch, callback) => error => {
  dispatch({ type: PROCESSING_DONE });
  callback(id, false, type, [
    { status: 'failed', message: 'Update Service: Failed' },
    // {
    //   status: 'pending',
    //   message: 'Sync to Global Search: Not Processed',
    // },
  ]);
  errorHandle(error);
};

const serviceBiller = {
  getListService,
  onGetListServiceSuccess,
  onGetListServiceError,
  getService,
  onGetServiceSuccess,
  onGetServiceError,
  syncConsent,
  onSyncConsentSuccess,
  onSyncConsentError,
  createNewService,
  onCreateNewServiceSuccess,
  onCreateNewServiceError,
  updateService,
  onUpdateServiceSuccess,
  onUpdateServiceError,
  getListBillerService,
  onGetListBillerServiceSuccess,
  onGetListBillerServiceError,
  updateStatus,
  onUpdateStatusSuccess,
  onUpdateStatusError,
};

export default serviceBiller;
